import React, { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme, Collapse, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { MdArtTrack, MdAccountBalanceWallet, MdDashboard } from "react-icons/md";
import { FiUserCheck } from "react-icons/fi";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useSelector, useDispatch } from "react-redux";
import { getDatosOperador } from "../../services/index.js";
import { setEmpleado } from "../../state";

// Sidebar menu item component
const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{ color: colors.grey[100] }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = ({ isAuthenticated = false }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const [isCollapsed, setIsCollapsed] = useState(() => isSmallScreen);
  const [selected, setSelected] = useState("Dashboard");
  const [isFormulariosOpen, setIsFormulariosOpen] = useState(true);
  const usuarioSitae = useSelector((state) => state.user);
  const [datosEmpleado, setDatosEmpleado] = useState({});
  const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(
    datosEmpleado[0]?.Codigo || "Usuario"
  )}&background=1e40af&color=fff`;
  //const [profilePic, setProfilePic] = useState("");

  useEffect(() => {
    // Actualiza el estado de colapso en función del tamaño de la pantalla
    setIsCollapsed(isSmallScreen);
  }, [isSmallScreen]);

  useEffect(() => {
    const fetchDatosGenerales = async () => {
      if (!usuarioSitae) return;
      const data = await getDatosOperador(usuarioSitae);
      setDatosEmpleado(data);
      dispatch(setEmpleado({ dataEmpleado: data }));
    };

    fetchDatosGenerales();
  }, [usuarioSitae, dispatch]);

  const sidebarStyles = {
    "& .pro-sidebar-inner": {
      background: `${colors.primary[400]} !important`,
    },
    "& .pro-icon-wrapper": {
      backgroundColor: "transparent !important",
    },
    "& .pro-inner-item": {
      padding: "5px 35px 5px 20px !important",
    },
    "& .pro-inner-item:hover": {
      color: "#67C4D6 !important",
    },
    "& .pro-menu-item.active": {
      color: "#287892 !important",
    },
  };

  return (
    <Box display={isAuthenticated ? "flex" : "none"}>
      <Box
        sx={{
          ...sidebarStyles,
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          width: isCollapsed ? "120px" : "300px",
          zIndex: 1300,
        }}
      >
        <ProSidebar collapsed={isCollapsed}>
          <Menu iconShape="square">
            <MenuItem
              onClick={() => setIsCollapsed(!isCollapsed)}
              icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
              style={{ margin: "10px 0 20px 0", color: colors.grey[100] }}
            >
              {!isCollapsed && (
                <Box display="flex" justifyContent="space-between" alignItems="center" ml="15px">
                  <Typography variant="h3" color={colors.grey[100]}>
                    SACC
                  </Typography>
                  <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                    <MenuOutlinedIcon />
                  </IconButton>
                </Box>
              )}
            </MenuItem>

            {!isCollapsed && (
              <Box mb="25px">
                <Box display="flex" justifyContent="center" alignItems="center">
                  <img
                    src={avatarUrl}
                    alt="avatar"
                    style={{ borderRadius: "50%", width: 100, height: 100 }}
                  />
                </Box>
                <Box textAlign="center">
                  <Typography
                    variant="h2"
                    color={colors.grey[100]}
                    fontWeight="bold"
                    sx={{ m: "10px 0 0 0" }}
                  >
                    {datosEmpleado[0]?.Empleado || datosEmpleado[0]?.Operador}
                  </Typography>
                  <Typography variant="h5" color={colors.greenAccent[500]}>
                    {datosEmpleado?.Acronimo || datosEmpleado[0]?.Codigo}
                  </Typography>
                </Box>
              </Box>
            )}

            <Box paddingLeft={isCollapsed ? undefined : "10%"}>
              <Item
                title="Inicio"
                to="/home"
                icon={<HomeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Datos Personales"
                to="/datosPersonales"
                icon={<FiUserCheck size={18} />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Consultar mis avisos"
                to="/consultas"
                icon={<MdArtTrack size={20} />}
                selected={selected}
                setSelected={setSelected}
              />
              {!isCollapsed && (
                <>
                  <Typography
                    variant="h6"
                    color={colors.grey[300]}
                    sx={{ m: "15px 0 5px 28px" }}
                    onClick={() => setIsFormulariosOpen(!isFormulariosOpen)}
                    style={{ cursor: "pointer" }}
                  >
                    Formularios
                  </Typography>
                  <Collapse in={isFormulariosOpen}>
                    <Item
                      title="Tarifa por Supervisión"
                      to="/tarifaSupervision"
                      icon={<MdAccountBalanceWallet size={20} />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Collapse>
                </>
              )}
              {isCollapsed && (
                <Item
                  title="Tarifa por Supervisión"
                  to="/tarifaSupervision"
                  icon={<MdAccountBalanceWallet size={20} />}
                  selected={selected}
                  setSelected={setSelected}
                />
              )}
              {!isCollapsed && (
                <Typography
                  variant="h6"
                  color={colors.grey[300]}
                  sx={{ m: "15px 0 5px 28px" }}
                  onClick={() => setIsFormulariosOpen(!isFormulariosOpen)}
                  style={{ cursor: "pointer" }}
                >
                  Consultas
                </Typography>
              )}
              <Item
                title="Dashboard"
                to="/dashboard"
                icon={<MdDashboard />}
                selected={selected}
                setSelected={setSelected}
              />
            </Box>
          </Menu>
        </ProSidebar>
      </Box>
      {/* Your right-side content goes here */}
      <Box
        sx={{
          flexGrow: 1,
          ml: isCollapsed ? "120px" : "300px",
          overflowY: "auto",
        }}
      >
        {/* Your main content component here */}
      </Box>
    </Box>
  );
};

export default Sidebar;
